<template>
  <vc-date-picker class="inline-block" v-model="date" :masks="masks" :disabled="readonly" @dayclick="updateDate" >
    <template v-slot="{ inputValue, togglePopover }">
      <div class="flex items-center relative">
        <vs-input class="w-full" :value="inputValue" @click="(!readonly)?togglePopover({ placement: 'auto-start' }):temp()" :readonly="readonly" :placeholder="placeholder"></vs-input>
        <vs-icon v-if="!readonly"
                 icon-pack="feather" icon="icon-calendar"
                 style="margin-top:6px; margin-bottom:6px; margin-right:1px; padding-left:6px; padding-right:6px; position: absolute; top:0; right:0; bottom:0; font-size:24px; border-left: 1px solid #cdcdcd; background-color: #fff;"
                 @click="(!readonly)?togglePopover({ placement: 'auto-start' }):temp()"
        ></vs-icon>
      </div>
    </template>
  </vc-date-picker>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import * as lang from 'vuejs-datepicker/src/locale'

export default {
  name: 'DateSelector',
  components: {
    Datepicker
  },
  props: {
    value: { type: String, default: '' },
    division: { type: String, default: '-' },
    format: { type: String, default: 'YYYY-MM-DD' },
    minimumView: { type: String, default: 'day'},
    maximumView: { type: String, default: 'year'},
    readonly: Boolean,
    placeholder: String,
  },
  watch: {
    value (data) {
      if (data) {
        this.date = new Date(data)
      } else {
        this.date = ''
      }
    },
  },
  data () {
    return {
      languages: lang,
      date:'',
      masks : {
        input : this.format
      }
    }
  },

  created () {
    this.date = new Date(this.value)
    this.div = this.division
  },

  methods:{
    updateDate (data) {
      this.$emit('input', new Date(this.date).format('yyyy-MM-dd'))
      this.$emit('change', this.date)
    },
    temp () {

    }
  }
}
</script>

<style scoped>
.right-icon{
  font-size:24px;
  padding:6px;
}
</style>
<style>

.vc-popover-content-wrapper.is-interactive {
  z-index:402;
}
</style>
